import { WalletIcon } from '@ankr.com/ui';

import { OauthIcon } from 'modules/auth/components/OauthIcon';
import { useAuth } from 'modules/auth/hooks/useAuth';

import { usePersonalAccountButtonIconStyles } from './usePersonalAccountButtonIconStyles';

export const PersonalAccountButtonIcon = () => {
  const { classes } = usePersonalAccountButtonIconStyles();

  const { isOAuth, walletIcon } = useAuth();

  if (isOAuth) {
    return <OauthIcon className={classes.oauthIcon} />;
  }

  return <WalletIcon icon={walletIcon} />;
};
